export enum DeliveryItems {
    all = "all",
    lineByLine = "line-by-line"
}